import { render, staticRenderFns } from "./impact-dashboard.vue?vue&type=template&id=56d2ae0c&scoped=true"
import script from "./impact-dashboard.ts?vue&type=script&lang=ts&external"
export * from "./impact-dashboard.ts?vue&type=script&lang=ts&external"
import style0 from "./impact-dashboard.scss?vue&type=style&index=0&id=56d2ae0c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d2ae0c",
  null
  
)

export default component.exports